if (!customElements.get('pdp-ugc-reviews-modal')) {
  class PdpUgcReviewsModal extends ModalDialog {
    constructor() {
      super();

      this.gallery = this.querySelector('.pdp-ugc-reviews-modal__images');
      this.galleryBox = this.querySelector('.pdp-ugc-reviews-modal__gallery');
      this.loadingEl = this.querySelector('.pdp-ugc-reviews-modal__loading');
      this.emptyEl = this.querySelector('.pdp-ugc-reviews-modal__empty');
      this.prevBtn = this.querySelector('.pdp-ugc-reviews-modal__nav--prev');
      this.nextBtn = this.querySelector('.pdp-ugc-reviews-modal__nav--next');
      this.dotsWrap = this.querySelector('.pdp-ugc-reviews-modal__dots');

      this.storeId = this.dataset.storeId;
      this.productId = this.dataset.productId;
      this.loadedProductId = null;
      this.photoCount = 0;

      this.prevBtn.addEventListener('click', () => this.scrollBySlide(-1));
      this.nextBtn.addEventListener('click', () => this.scrollBySlide(1));
      this.gallery.addEventListener('scroll', () => this.updateNavState());
    }

    show(opener) {
      super.show(opener);

      this.resetToFirstSlide();

      if (this.loadedProductId === this.productId) return;
      this.loadedProductId = this.productId;
      this.fetchPhotos();
    }

    resetToFirstSlide() {
      this.gallery.scrollLeft = 0;
      this.dotsWrap.querySelectorAll('.pdp-ugc-reviews-modal__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === 0);
      });
      this.updateNavState();
    }

    async fetchPhotos() {
      this.gallery.innerHTML = '';
      this.emptyEl.hidden = true;
      this.galleryBox.hidden = true;
      this.loadingEl.hidden = false;

      try {
        const url = `https://storefront-api.loox.io/storefront/v1/store/${this.storeId}/product-reviews?product_id=${this.productId}&limit=25`;
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Loox request failed: ${response.status}`);
        const data = await response.json();

        const photos = [];
        (data.reviews || []).forEach((review) => {
          (review.media || []).forEach((item) => {
            if (item.type === 'photo' && item.url) photos.push(item.url);
          });
        });

        if (!photos.length) {
          this.emptyEl.hidden = false;
          return;
        }

        this.galleryBox.hidden = false;
        this.gallery.innerHTML = photos
          .map(
            (src, index) => `
              <img
                class="pdp-ugc-reviews-modal__image"
                src="${src}"
                loading="${index === 0 ? 'eager' : 'lazy'}"
                alt=""
              >
            `
          )
          .join('');

        this.gallery.scrollLeft = 0;
        this.photoCount = photos.length;
        const hasMultiple = photos.length > 1;
        this.prevBtn.classList.toggle('hidden', !hasMultiple);
        this.nextBtn.classList.toggle('hidden', !hasMultiple);
        this.dotsWrap.classList.toggle('hidden', !hasMultiple);

        this.maxDots = Math.min(photos.length, 6);
        this.dotsWrap.innerHTML = hasMultiple
          ? Array.from({ length: this.maxDots })
              .map(
                (_, index) => `
                  <button
                    type="button"
                    class="pdp-ugc-reviews-modal__dot${index === 0 ? ' is-active' : ''}"
                    aria-label="Show photo ${index + 1}"
                  ></button>
                `
              )
              .join('')
          : '';

        this.dotsWrap.querySelectorAll('.pdp-ugc-reviews-modal__dot').forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.gallery.scrollTo({ left: index * this.gallery.clientWidth, behavior: 'smooth' });
          });
        });

        this.updateNavState();
      } catch (error) {
        console.error('[pdp-ugc-reviews-modal]', error);
        this.emptyEl.hidden = false;
      } finally {
        this.loadingEl.hidden = true;
      }
    }

    scrollBySlide(direction) {
      this.gallery.scrollBy({ left: direction * this.gallery.clientWidth, behavior: 'smooth' });
    }

    updateNavState() {
      const maxScroll = this.gallery.scrollWidth - this.gallery.clientWidth;
      const atStart = this.gallery.scrollLeft <= 4;
      const atEnd = this.gallery.scrollLeft >= maxScroll - 4;

      if (!this.prevBtn.classList.contains('hidden') || !this.nextBtn.classList.contains('hidden')) {
        this.prevBtn.style.visibility = atStart ? 'hidden' : 'visible';
        this.nextBtn.style.visibility = atEnd ? 'hidden' : 'visible';
      }

      if (this.photoCount > 1) {
        const activeIndex = Math.round(this.gallery.scrollLeft / this.gallery.clientWidth);
        const activeDotIndex = Math.min(activeIndex, this.maxDots - 1);
        this.dotsWrap.querySelectorAll('.pdp-ugc-reviews-modal__dot').forEach((dot, index) => {
          dot.classList.toggle('is-active', index === activeDotIndex);
        });
      }
    }
  }

  customElements.define('pdp-ugc-reviews-modal', PdpUgcReviewsModal);
}
